import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import type { IResponseContact } from 'entities/Contacts/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventConversationShortcodeOptOutChanged = () => {
  const { websocket, contactsStore } = useEntitiesContext()
  const handle = (data: IResponseContact) => contactsStore.updateItem(data)

  useEffect(() => websocket.on(WebsocketEvent.ConversationShortcodeOptOutChanged, handle), [])
}
